import { useTranslation } from 'react-i18next'

import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/control-room/process/$processId/labware/$labwareId',
)({
  component: ProcessLabwarePage,
})

function ProcessLabwarePage() {
  const { t } = useTranslation()
  const { processId, labwareId } = Route.useParams()

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold">
        {t('controlRoom.labwareDetails.title')}
      </h1>
      <p className="text-muted-foreground">
        {t('controlRoom.labwareDetails.processId', { processId })}
      </p>
      <p className="text-muted-foreground">
        {t('controlRoom.labwareDetails.labwareId', { labwareId })}
      </p>
    </div>
  )
}
